import { useContext } from "react";
import { Routes, Route } from "react-router-dom"
import { AppUserContext } from "../../App";
import { ErrorLoading } from "../../components/loading";
import { NewFeeNote } from "./feenote-manipulation";
import FeeNoteDetails from "./view-feenote";
import ViewFeeNotes from "./view-feenotes";

const FeeNotes = () => {

    const { profile } = useContext(AppUserContext);

    if ((profile.roles.indexOf("finance") === -1) && (profile.roles.indexOf("admin") === -1)) {
        return <ErrorLoading>You do not have the permission to access this module.</ErrorLoading>
    }

    return (
        <Routes>
            <Route path="/new" element={<NewFeeNote />} />
            <Route path="/:noteid/*" element={<FeeNoteDetails />} />
            <Route path="/" element={<ViewFeeNotes />} />
        </Routes>
    )
}

export default FeeNotes;